/**
 * A clip's 0–100 score as a ring. The score ranks a clip against the other
 * clips from the same video; it is not a forecast of views.
 */
const ScoreRing = ({ score }: { score: number }) => {
  const value = Math.max(0, Math.min(100, Math.round(score)))
  const radius = 18
  const circumference = 2 * Math.PI * radius
  const tone = value >= 75 ? 'text-success-600' : value >= 50 ? 'text-primary-600' : 'text-gray-500'
  return (
    <div className="relative h-12 w-12 shrink-0" role="img" aria-label={`Score ${value} out of 100, ranked within this video`}>
      <svg viewBox="0 0 44 44" className="h-12 w-12 -rotate-90">
        <circle cx="22" cy="22" r={radius} fill="none" strokeWidth="4" className="stroke-current text-gray-300" />
        <circle
          cx="22"
          cy="22"
          r={radius}
          fill="none"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - value / 100)}
          className={`stroke-current ${tone}`}
        />
      </svg>
      <span className="absolute inset-0 flex items-center justify-center text-sm font-bold text-gray-900">{value}</span>
    </div>
  )
}

export default ScoreRing
